import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIModule } from 'libs/ui';
import { CPESharedModule } from '../shared/shared.module';
import { DrawerModule } from 'primeng/drawer';
import { SelectModule } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { MultiSelectModule } from 'primeng/multiselect';
import { CarbonFootprintSidebarComponent } from './components'

const modules = [
    DrawerModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UIModule,
    CPESharedModule,
    SelectModule,
    DatePickerModule,
    CheckboxModule,
    ToastModule,
    TooltipModule,
    MultiSelectModule,
    AutoCompleteModule,
    RadioButtonModule,
    AccordionModule
  ];

  const components = [
    CarbonFootprintSidebarComponent
  ];

  @NgModule({
    imports: modules,
    declarations: components,
    exports: components,
    providers: [
      
    ]
  })
  export class CarbonFootprintModule {
    static forRoot(): ModuleWithProviders<CarbonFootprintModule> {
      return {
        ngModule: CarbonFootprintModule,
        providers: []
      };
    }
  }
  